export default __webpack_public_path__ + "assets/chromeext.ee8b1d12e9ad7fa06a9965d0c4bfc1b8.png";